<template>
  <div>
    <b-card>
      <b-alert variant="danger" :show="errors.length > 0">
        <p v-for="x in errors" v-bind:key="x">{{ x }}</p>
      </b-alert>
      <b-form @submit.stop.prevent="onSubmit">
        <div>
          <b-row>
            <b-col>
              <b-form-group
                id="input-group-1"
                label="شماره شبا: "
                label-for="input-1"
              >
                <b-input-group size="lg" append="IR">
                  <b-input
                    style="word-spacing: 8px"
                    maxlength="30"
                    class="text-right ltr"
                    id="input_card_iban"
                    v-model="Input.iban"
                    placeholder="-- ---- ---- ---- ---- ---- --"
                    required
                  ></b-input>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col> </b-col>
            <b-col> </b-col>

            <b-col> </b-col>
          </b-row>
        </div>

        <br />
        <b-button type="submit" class="mr-3" variant="success"
          >استعلام</b-button
        >
      </b-form>
      <div class="col-md-12" v-if="estelamResult != null">
        <br />
        <br />
        <h3>نتیجه استعلام</h3>
        <b-form-group label="شماره شبا:">
          <div class="form-control">
            {{ estelamResult.IBAN }}
          </div>
        </b-form-group>
        <b-form-group label="نام بانک:">
          <div class="form-control">
            {{ estelamResult.bankName }}
          </div>
        </b-form-group>
        <b-form-group label="شماره حساب:">
          <div class="form-control">
            {{ estelamResult.deposit }}
          </div>
        </b-form-group>
        <b-form-group label="توضیحات حساب:">
          <div class="form-control">
            {{ estelamResult.depositComment }}
          </div>
        </b-form-group>
        <b-form-group label="مالکان:">
          <div
            class="form-control"
            v-for="x in estelamResult.depositOwners"
            v-bind:key="x.firstName + x.lastName"
          >
            {{ x.firstName + " " + x.lastName }}
          </div>
        </b-form-group>
      </div>
    </b-card>
  </div>
</template>

<style>
.aligner {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import httpHelper from "@/helpers/httpHelper";
import persianDate from "../../helpers/persianDate";
import MDDropdown from "../../components/MDDropdown";
export default {
  name: "GetInfoWithIban",
  components: {
    persianDate,
    MDDropdown,
  },
  data: function () {
    return {
      estelamResult: null,
      errors: [],
      Input: {
        iban: "",
      },
    };
  },

  methods: {
    onSubmit(evt) {
      this.errors = [];

      httpHelper
        .postData("finnotech/getinfowithiban", this.Input)
        .then((response) => {
          if (response.success) {
            if (response.result.status) {
              this.estelamResult = response.result.data;
            } else {
              this.estelamResult = null;
              this.errors.push(response.result.data.error.message);
            }
          } else {
            for (var key in response.error) {
              response.error[key].forEach((element) => {
                this.errors.push(element);
              });
            }
          }
        });
    },
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      {
        title: "تایید مدارک",
        route: "/getinfowithiban",
      },
      {
        title: "استعلام شبا بانکی",
      },
    ]);
  },
};
</script>
